import { waitlistBaseModel } from './crud';
import { waitlistUpdatePosition } from './waitlistUpdatePosition';
import { waitlistsBulkRemove } from './waitlistsBulkRemove';

export * from './types';

export const useWaitlistsById = waitlistBaseModel.fetchById();
export const useWaitlistsByIds = waitlistBaseModel.fetchByIds();
export const useWaitlistsMany = waitlistBaseModel.fetchMany();
export const useWaitlistsCount = waitlistBaseModel.count();
export const useWaitlistsManyInfiniteQuery = waitlistBaseModel.fetchPaginated();
export const useWaitlistsUpdateOne = waitlistBaseModel.edit();
export const useWaitlistsCreateOne = waitlistBaseModel.create();
export const useWaitlistsRemoveOne = waitlistBaseModel.delete();
export const useWaitlistsRemoveByIds = waitlistBaseModel.deleteByIds();

export const useWaitlistsByIdV2 = waitlistBaseModel.fetchByIdV2();
export const useWaitlistsByIdsV2 = waitlistBaseModel.fetchByIdsV2();
export const useWaitlistsManyV2 = waitlistBaseModel.fetchManyV2();
export const useWaitlistsCountV2 = waitlistBaseModel.countV2();
export const useWaitlistsManyInfiniteQueryV2 =
  waitlistBaseModel.fetchPaginatedV2();
export const useWaitlistsUpdateOneV2 = waitlistBaseModel.editV2();
export const useWaitlistsCreateOneV2 = waitlistBaseModel.createV2();
export const useWaitlistsRemoveOneV2 = waitlistBaseModel.deleteV2();
export const useWaitlistsRemoveByIdsV2 = waitlistBaseModel.deleteByIdsV2();

export const useWaitlistUpdatePosition = waitlistUpdatePosition();
export const useWaitlistsBulkRemove = waitlistsBulkRemove();

// New names based on Mongoose queries
export const useWaitlistById = waitlistBaseModel.fetchById();
export const useWaitlistByIds = waitlistBaseModel.fetchByIds();
export const useWaitlistMany = waitlistBaseModel.fetchMany();
export const useWaitlistCount = waitlistBaseModel.count();
export const useWaitlistPagination = waitlistBaseModel.fetchPaginated();
export const useWaitlistUpdateOne = waitlistBaseModel.edit();
export const useWaitlistCreateOne = waitlistBaseModel.create();
export const useWaitlistRemoveOne = waitlistBaseModel.delete();
export const useWaitlistRemoveByIds = waitlistBaseModel.deleteByIds();

export const useWaitlistByIdV2 = waitlistBaseModel.fetchByIdV2();
export const useWaitlistByIdsV2 = waitlistBaseModel.fetchByIdsV2();
export const useWaitlistManyV2 = waitlistBaseModel.fetchManyV2();
export const useWaitlistCountV2 = waitlistBaseModel.countV2();
export const useWaitlistPaginationV2 = waitlistBaseModel.fetchPaginatedV2();
export const useWaitlistUpdateOneV2 = waitlistBaseModel.editV2();
export const useWaitlistCreateOneV2 = waitlistBaseModel.createV2();
export const useWaitlistRemoveOneV2 = waitlistBaseModel.deleteV2();
export const useWaitlistRemoveByIdsV2 = waitlistBaseModel.deleteByIdsV2();
